module.exports = __webpack_public_path__ + "img/1.816f716f.jpg";